import "./NewsItem.css"

import {Link} from "react-router-dom";
// import {Link, useParams} from "react-router-dom";
import jetrelIcon from "../images/avatars/jetrel.png"
import neoriceIcon from "../images/avatars/Neoriceisgood.png"
import newsIcon from "../images/news_icon.png"
import penguinIcon from "../images/avatars/penguin.png"
import zalanderIcon from "../images/avatars/Zalander.png"
import DateFormatter from "../DateFormatter";

function NewsItem({ newsItem, commentsHandler, addCommentHandler }) {
  let icons = {
    'Neoriceisgood': neoriceIcon,
    'jetrel': jetrelIcon,
    'penguin': penguinIcon,
    'Zalander': zalanderIcon,
  };
  // const comments = useSelector(state => state.comments);

  if (!newsItem || newsItem.loading || newsItem.failed) {
    return null;
  }

  let dateString = '';
  if (newsItem.date) {
    dateString = DateFormatter.formatDate(newsItem.date);
  }

  let commentsOnClick = (event) => {
    if (commentsHandler) {
      event.preventDefault();
      commentsHandler();
    }
  }

  let addCommentOnClick = (event) => {
    if (addCommentHandler) {
      event.preventDefault();
      addCommentHandler();
    }
  }

  return (
    <div className='news_post'>
      <div className='top'>
        
        <img src={icons[newsItem.username]} alt={`${newsItem.username}'s avatar`} className="avatar" />
        <div className="news_metadata">
          <h2>{newsItem.title}</h2>
          <div className='content'>
            <span className='date'>{dateString}</span><br />
            <span className='post_credit'>{`By: ${newsItem.username}`}</span>
          </div>
        </div>
        <img className="news_icon" src={newsIcon} alt=''/>
        
      </div>
      <div className='middle'>{ newsItem.content.split(/(?:\r\n){2,}/).map( (paragraph, i) =>
        <p key={i}>{paragraph.replaceAll(/â€[“™¦]/g, (chr) => chr === "â€¦" ? "..." : "'")}</p>
      ) }
      </div>
      <div className='bottom'>
        <Link to={`/news/${newsItem.id}#comments`} onClick={commentsOnClick}>
          {`Comments (${newsItem.commentCount})`}
        </Link>
        {" - "}
        <Link to={`/news/${newsItem.id}#comment_form`} onClick={addCommentOnClick}>Add comment</Link>
      </div>
    </div>
  );
}

export default NewsItem;
